import { LS_CLIENT_TYPE } from '@/constants/common';

import { OperationType } from '@/types/user';

import { readLocal, removeLocal, saveLocal } from './browser';

export function saveOperationType(type?: OperationType | '') {
  saveLocal(LS_CLIENT_TYPE, type);
}

export function getOperationType(): OperationType | undefined {
  return readLocal(LS_CLIENT_TYPE);
}

export function clearOperationType() {
  removeLocal(LS_CLIENT_TYPE);
}
